export default function initProgressForm() {
	const $progressFormNext = document.querySelector("[data-progress-form-next]");
	const $progressFormTarget = document.querySelector(
		"[data-progress-form-target]"
	);
	const $progressFormBack = document.querySelector("[data-progress-form-back]");
	const $progressFormBackTarget = document.querySelector(
		"[data-progress-form-back-target]"
	);

	// Fields
	const emailField = document.querySelector("#id_email");
	const phoneField = document.querySelector("#id_phone");
	const dateField = document.querySelector("#id_painting_date");

	const prefilledDate = getUrlParameter("prefilldate");

	if (prefilledDate) {
		dateField.value = prefilledDate;
	}

	const sectionOneValid = _ => {
		return (
			dateField.validity.valid &&
			(emailField.value !== "" || phoneField.value !== "")
		);
	};

	if (dateField && dateField.dataset.closedDates) {
		dateField.addEventListener("blur", e => {
			let dates = dateField.dataset.closedDates.split(",");
			if (dates.indexOf(dateField.value) !== -1) {
				dateField.parentNode.querySelector("[data-errors]").innerText =
					"Sorry, the maximum number of permits have been issued for this date. Please select another.";
				dateField.value = "";
			}
		});
	}

	if ($progressFormNext) {
		$progressFormNext.addEventListener("click", e => {
			if (sectionOneValid()) {
				$progressFormNext.parentNode.classList.remove("is-active");
				$progressFormTarget.classList.add("is-active");
				e.preventDefault();
			} else {
				$progressFormNext.parentNode.querySelector("[data-errors]").innerText =
					"Please fill in an email OR phone number and select a date.";
			}
		});

		$progressFormBack.addEventListener("click", e => {
			$progressFormBack.parentNode.parentNode.classList.remove("is-active");
			$progressFormBackTarget.classList.add("is-active");
			e.preventDefault();
		});
	}

	const $tabTriggers = document.querySelectorAll("[data-tabs-trigger]");
	const $tabTargets = document.querySelectorAll("[data-tabs-target]");

	$tabTriggers.forEach($t => {
		$t.addEventListener("click", e => {
			let id = $t.dataset.tabsTrigger;
			$tabTargets.forEach($ta => $ta.classList.remove("is-active"));
			$tabTriggers.forEach($tr => $tr.classList.remove("is-active"));
			$t.classList.add("is-active");
			document
				.querySelector(`[data-tabs-target="${id}"]`)
				.classList.add("is-active");
			e.preventDefault();
		});
	});
}

function getUrlParameter(name) {
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
	var results = regex.exec(location.search);
	return results === null
		? ""
		: decodeURIComponent(results[1].replace(/\+/g, " "));
}
